import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { AbstractControl, FormControl, FormGroup } from "@angular/forms";
import { groupBy, sortBy } from "lodash";

@Component({
  selector: "lhpe-select",
  templateUrl: "./select.component.html",
  styleUrls: ["./select.component.scss"],
})
export class SelectComponent implements OnInit {
  @Input() formGroup?: FormGroup;
  @Input() control?: FormControl;
  @Input() placeholder?: string;
  @Input() controlName!: string | number | null;
  @Input() required?: boolean;
  @Input() options?: any[];
  @Input() multiple?: boolean;
  @Input() optionValue?: string;
  @Input() color?: string;
  //Use when option of options is value and name, like when passing an array of a primitive and not an object
  @Input() optionIsSelf?: boolean;
  @Input() displayValue?: string;
  @Input() groupBy?: string;
  @Input() isOptionDisabled?: (option: any) => boolean;
  @Output() change = new EventEmitter<any>();
  formControl!: FormControl;

  groupedOptions?: any;

  constructor() {}

  ngOnInit(): void {
    if(this.groupBy !== undefined){
      let grouped = groupBy(this.options, this.groupBy)
      this.groupedOptions = Object.keys(grouped).map((key) => {
        return {
          name: key,
          options: sortBy(grouped[key], 'label')
        }
      })
      //console.log('GROUPED', this.groupedOptions)
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!this.color) {
      this.color = "lightGreen";
    }
    if (changes.formGroup) {
      this.formControl! = this.formGroup!.get(
        this.controlName as string,
      )! as FormControl;
    } else if (changes.control) {
      this.formControl = this.control!;
    }
  }

  onChange(event: any) {
    this.change?.emit(event);
  }

  getErrorMessage(formControl: AbstractControl | undefined) {
    if (formControl) {
    }
    return "";
  }
}
